import { request, requestList, buildQuery, orgBase } from '@/api/http'
import type { Alert, AlertConfig, AlertRollup, AlertEvent, AlertSyncResult } from '@/api/types'

export const alertsApi = {
  list(
    orgId: string,
    params?: { inventory_id?: string; source_id?: string; kind?: string; limit?: number }
  ): Promise<Alert[]> {
    return requestList(`${orgBase(orgId)}/alerts${params ? buildQuery(params) : ''}`)
  },
  rollup(orgId: string): Promise<AlertRollup> {
    return request(`${orgBase(orgId)}/alerts/rollup`)
  },
  getConfig(orgId: string): Promise<AlertConfig> {
    return request(`${orgBase(orgId)}/alerts/config`)
  },
  setConfig(orgId: string, body: AlertConfig): Promise<AlertConfig> {
    return request(`${orgBase(orgId)}/alerts/config`, { method: 'PUT', body: JSON.stringify(body) })
  },
  escalate(
    orgId: string,
    body: { asset_id: string; to: string; message: string }
  ): Promise<Alert> {
    return request(`${orgBase(orgId)}/alerts/escalate`, { method: 'POST', body: JSON.stringify(body) })
  },
  // Persisted alert-event feed.
  events(
    orgId: string,
    params?: { severity?: string; scope_type?: string; status?: string; limit?: number }
  ): Promise<AlertEvent[]> {
    return requestList(`${orgBase(orgId)}/alert-events${params ? buildQuery(params) : ''}`)
  },
  unreadCount(orgId: string): Promise<{ count: number }> {
    return request(`${orgBase(orgId)}/alert-events/unread-count`)
  },
  syncEvents(orgId: string): Promise<AlertSyncResult> {
    return request(`${orgBase(orgId)}/alert-events/sync`, { method: 'POST' })
  },
  ackEvent(orgId: string, id: string): Promise<{ status: string }> {
    return request(`${orgBase(orgId)}/alert-events/${id}/ack`, { method: 'POST' })
  },
  unackEvent(orgId: string, id: string): Promise<{ status: string }> {
    return request(`${orgBase(orgId)}/alert-events/${id}/unack`, { method: 'POST' })
  },
  resolveEvent(orgId: string, id: string): Promise<{ status: string }> {
    return request(`${orgBase(orgId)}/alert-events/${id}/resolve`, { method: 'POST' })
  },
  reopenEvent(orgId: string, id: string): Promise<{ status: string }> {
    return request(`${orgBase(orgId)}/alert-events/${id}/reopen`, { method: 'POST' })
  },
}
